
import styled from 'styled-components';

export const Wrapper = styled.div`
  padding: 2rem 0;
  text-align:center;
`;

export const Grid = styled.div`
  display: grid;
  align-items: center;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: 8fr;
  gap: 1.2rem 1.2rem;
  .flippy-container{
    width:100% !important;
  }
  margin-right:0 !important;
  width:100% !important;
  position:relative;
  animation: mymove 4s;
  @keyframes mymove{
    from{left:-50%}
    to{left:0%}
  }


  img{
    width:120px;
    height: 100px;
  }

  ._2yKGs{
    color: ${({ theme }) => (theme === 'light' ? '#212121' : '#fff')} !important;
  }
  ._xsi02{
    background-color: ${({ theme }) => (theme === 'light' ? '#fff' : '#212121')} ;
    margin-right:0 !important;
    width:100% !important;
    color: ${({ theme }) => (theme === 'light' ? '#212121' : '#fff')} !important;
  }
  .kbtwje{
    background-color: ${({ theme }) => (theme === 'light' ? '#fff' : '#212121')} ;
  }
  
  @media (max-width: 960px) {
    grid-template-columns: repeat(1, 1fr);
    img{
      width:120px;
      height: 100px;
    }
  }

  @media (max-width: 680px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

export const Item = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden;
  box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.11);

  h4 {
    color: ${({ theme }) => (theme === 'light' ? '#212121' : '#fff')} !important;
  }

  p {
    color: ${({ theme }) => (theme === 'light' ? '#707070' : '#c7c7c7')} !important;
  }
`;

export const Content = styled.div`
  div{
    display: flex;
  }
  div h4{
    margin-bottom:10%;
    margin-left:2%;
  }
`;

export const Stats = styled.div`
  display: flex;
  align-items: center;
  color: ${({ theme }) => (theme === 'light' ? '#000' : '#fff')};
  div {
    
    display: flex;
    &:first-child {
      margin-right: 0.5rem;
    }

    img {
      margin: 0;
    }

    svg path {
      fill: ${({ theme }) => (theme === 'light' ? '#000' : '#fff')};
    }

    span {
      color: ${({ theme }) => (theme === 'light' ? '#000' : '#fff')};
      margin-left: 0.5rem;
    }
  }
`;
